import { BackendAlarm } from './alarm-definitions/backend-alarm';
import { TranslateModel } from '../shared/translate.model';

export class AlarmMessage<TAlarmType extends BackendAlarm = BackendAlarm> {
  constructor(
    public message: string,
    public timestamp: Date | number,
    public metadata: TAlarmType,
    public severity: 'danger' | 'warning' | 'info',
    public translate: TranslateModel[]
  ) {
  }
}
